import { Button as ButtonAnt, Collapse } from "antd";
import styled from "styled-components";
import { CaretRightOutlined } from "@ant-design/icons";

export const Button = styled(ButtonAnt)`
  border-radius: 0.3rem;
`;

export const BoxActions = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  padding: 1rem;
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  box-shadow: 0 -0.25rem 0.5rem rgba(0, 0, 0, 0.05);
`;

export const CourseSelected = styled.div`
  font-weight: bold;
  color: var(--gray-700);
`;

export const CourseDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const CourseDetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
`;

interface IScoreTag {
  status?: "success" | "error" | "info" | "warning";
}

export const ScoreTag = styled.div<IScoreTag>`
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-weight: bold;

  ${({ status }) => {
    switch (status) {
      case "success":
        return `
          background-color: rgba(82, 196, 26, 0.1);
          color: #52c41a;
        `;
      case "error":
        return `
          background-color: rgba(255, 77, 79, 0.1);
          color: #ff4d4f;
        `;
      case "warning":
        return `
          background-color: rgba(250, 173, 20, 0.1);
          color: #faad14;
        `;
      case "info":
      default:
        return `
          background-color: rgba(24, 144, 255, 0.1);
          color: #1890ff;
        `;
    }
  }}
`;

export const ContainerCourses = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .ant-collapse-borderless {
    border: none !important;
    background-color: transparent !important;
  }
`;

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-item {
    margin-bottom: 1rem;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #f0f0f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .ant-collapse-header {
    padding: 12px 16px !important;
    background-color: #fafafa;
  }

  .ant-collapse-content-box {
    padding: 16px !important;
  }
`;

export const CourseHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CourseMainInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

export const BoxMainInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

export const CourseIdContainer = styled.div`
  font-weight: bold;
  color: #666;
  margin-right: 8px;
`;

export const CourseNameContainer = styled.div`
  font-weight: 500;
  flex: 1;
`;

export const CourseProgressContainer = styled.div`
  margin-top: 12px;
  width: 100%;
`;

export const CourseStatusContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
`;

interface ICustomArrow {
  isActive: boolean;
}

export const CustomArrow = styled(CaretRightOutlined)<ICustomArrow>`
  font-size: 16px;
  color: var(--orange-250);
  transition: transform 0.3s ease;
  transform: ${({ isActive }) => (isActive ? "rotate(90deg)" : "rotate(0deg)")};
  cursor: pointer;

  &:hover {
    color: var(--orange-250);
  }
`;
